import React, { useState, useEffect,useContext } from 'react'
import DashboardLayout from '../../layoutcontainers/DashboardLayout'
import MaterialDataGrid from '../../components/MaterialDataGrid'
import MaterialTypography from '../../components/MaterialTypography'
import { Card, CardHeader, Stack } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import MaterialButton from '../../components/MaterialButton'
import AddIcon from '@mui/icons-material/Add';
import BASEURL from '../Utils/Baseurl';
import axios from 'axios';
import { Done, Close } from '@mui/icons-material'
import {useUserDetails} from '../../context/auth'
const ComponentManagement = () => {

    const navigate = useNavigate()

    const {setcomponentdisplay,setTogglePage,togglePage,AccessData} = useUserDetails()

    const [pageState, setPageState] = useState({
        loading: false,
        error: false,
        message: "",
        state: 'init'
    })

    const [componentList, setComponentList] = useState([])

    useEffect(() => {
        onComponentSubmit();
    }, []);

    const ComponentListTable = {
        columns: [
            {
                field: "componentName",
                headerName: "Component Name",
                flex: 1,
                disableColumnMenu: true,
                editable: false,
                sortable: true,
            },
            {
                field: "abbreviation",
                headerName: "Abbreviation",
                flex: 1,
                editable: false,
                disableColumnMenu: true,
                sortable: true,
            },
            {
                field: "type",
                headerName: "Type",
                flex: 1,
                disableColumnMenu: true,
                editable: false,
                sortable: true,
            },
            {
                field: "description",
                headerName: "Description",
                flex: 1,
                disableColumnMenu: true,
                editable: false,
                sortable: true,
            },
          
        ],
        rows: componentList.map((component) => {

            const updatedComponent = Object.keys(component).reduce((acc, key) => {
                acc[key] = typeof component[key] === "boolean" ? (component[key] ? 'Yes' : 'No') : key === "type" ? component[key].charAt(0).toUpperCase()+component[key].slice(1) : component[key];
                return acc;
            }, {});
        
            return updatedComponent
        })
    }

    const handleNewComponent = () => {
        navigate('/component/add-component')
        setTogglePage({
          
            view: false,
            edit:false
        })
        setcomponentdisplay(false)
    }

    const onEmployeeListClick = (e) => {
       
        setcomponentdisplay(true)
        
        if (e?.id) {
            navigate(`/component/add-component?id=${e?.id}`);
        }
    }


    const onComponentSubmit = async () => {
        const query = `
          query {
  allComponentmaster{
  id
    componentName
    abbreviation
    type
    description
    dependsOnPaymentDays
    statisticalComponent
    taxApplicable
    removeIfZero
    fullTaxOnPayrollDate
    includeFromTotal
    roundToInteger
    disabled
  }
}

        `;

        try {
            setPageState({ ...pageState, loading: true });

            const response = await axios.post(BASEURL, {
                query: query
            }, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            console.log("response:",response.data);
            
 
            // Extract Employee data from the response
            const EmpList = response.data.data.allComponentmaster;
            setComponentList(EmpList);
            setPageState({ ...pageState, loading: false, state: 'success' });
        } catch (error) {
            console.error('ResponseError:', error.response.data);
            setPageState({ ...pageState, loading: false, error: true, message: error.message });
        }
    };

    return (
        <DashboardLayout>
            <Card >
                <CardHeader title={(
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={2}
                    >
                        <Stack direction="column" spacing={0}>
                            <MaterialTypography variant="h5" fontWeight="medium">
                                Components list
                            </MaterialTypography>
                            {/* <MaterialTypography variant="caption" color="text">
                                List of components that you can get details of components.
                            </MaterialTypography> */}
                        </Stack>
                        {AccessData &&
                Array.isArray(AccessData) &&
                AccessData.some(
                  (item) =>
                    item.component === "AddComponent" && item.can_access
                ) && (
                        <MaterialButton
                            variant="gradient"
                            color="dark"
                            size="small"
                            startIcon={<AddIcon />}
                            onClick={() => handleNewComponent()}
                        >
                            Component
                        </MaterialButton>
                )}
                    </Stack>


                )} />
                <MaterialDataGrid
                    customHeight={500}
                    rows={ComponentListTable.rows}
                    columns={ComponentListTable.columns}
                    checkboxSelection={false}
                    isSelectable={false}
                    onRowClick={onEmployeeListClick}
                    loading={pageState.loading}
                    localeText={{
                        noRowsLabel: (
                            <Stack direction="column" alignItems="center" justifyContent="center" spacing={1}>
                                <MaterialTypography variant="body2" fontWeight="medium" color="text">
                                    No components found
                                </MaterialTypography>
                                <MaterialTypography variant="caption" color="text">
                                    You have not yet add any components details. Click on the "Add Component" button to start adding component details.
                                </MaterialTypography>
                            </Stack>
                        )
                    }}
                />
            </Card>
        </DashboardLayout>
    )
}

export default ComponentManagement
